'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _react2.default.createClass({
  displayName: 'GoogleFont',

  propTypes: {
    typography: _react2.default.PropTypes.object.isRequired
  },

  render: function render() {
    // Create family + styles string
    var fontsStr = '';
    if (this.props.typography.options.googleFonts) {
      var fonts = this.props.typography.options.googleFonts.map(function (font) {
        var str = '';
        str += font.name.split(' ').join('+');
        str += ':';
        str += font.styles.join(',');

        return str;
      });

      fontsStr = fonts.join('|');

      if (fontsStr) {
        return _react2.default.DOM.link({
          href: '//fonts.googleapis.com/css?family=' + fontsStr,
          rel: 'stylesheet',
          type: 'text/css'
        });
      }
    }
    return null;
  }
});


//////////////////
// WEBPACK FOOTER
// ../~/react-typography/dist/GoogleFont.js
// module id = 453
// module chunks = 0